// extracted by mini-css-extract-plugin
export var statItem = "_ca-1";
export var statsRow = "_ca-0";